export const PAGES_MENU = [
  {
    path: 'pages',
    children: [
      {
        path: 'dashboard',
        data: {
          menu: {
            title: 'Dashboards',
            icon: 'ion-android-home',
            selected: false,
            expanded: false,
            order: 0
          }
        },
        children: [
          {
            path: 'allDevices',
            data: {
              menu: {
                title: 'general.menu.all_devices',
              }
            }
          },
          {
            path: 'dashboardMap',
            data: {
              menu: {
                title: 'Feeds and Alarms',
              }
            }
          },
          {
            path: 'meteringDashboard',
            data: {
              menu: {
                title: 'Metering Dashboard'
              }
            }
          },
          {
            path: 'deviceAlerts',
            data: {
              menu: {
                title: 'Diagnostics'
              }
            }
          },
        ]
      },
      {
        path: 'dashboard',
        data: {
          menu: {
            title: 'Custom Dashboards',
            icon: 'ion-wrench',
            selected: false,
            expanded: false,
            order: 0
          }
        },
        children: [
          {
            path: '',
            data: {
              menu: {
                title: ''
              }
            }
          },
        ]
      },
      {
        path: 'dashboardSettings',
        data: {
          menu: {
            title: 'Device Management',
            icon: 'ion-android-settings',
            selected: false,
            expanded: false,
            order: 0
          }
        },
        children: [
          {
            path: 'manageDevices',
            data: {
              menu: {
                title: 'Manage Devices',
              }
            }
          },
          {
                  path: 'triggers',
                  data: {
                    menu: {
                      title: 'Trigger Settings',
                      icon: ""
                    }
                  }
          }
        ]
      },
      {
        path: 'userSettings',
        data: {
          menu: {
            title: 'User Management',
            icon: 'ion-ios-people',
            selected: false,
            expanded: false,
            order: 0
          }
        },
        children: [
          {
            path: 'manageUsers',
            data: {
              menu: {
                title: 'Manage Users'
              }
            }
          },
          {
            path: 'userActivity',
            data: {
              menu: {
                title: 'User Activity'
              }
            }
          }
        ]
      },
    ]
  }
];



// WEBPACK FOOTER //
// ./src/app/pages/pages.menu.ts